module.exports = __webpack_public_path__ + "img/qrcode.1c79d9ab.png";